import { render, staticRenderFns } from "./PlayTabs.vue?vue&type=template&id=50f91a61&scoped=true"
import script from "./PlayTabs.vue?vue&type=script&lang=js"
export * from "./PlayTabs.vue?vue&type=script&lang=js"
import style0 from "./PlayTabs.vue?vue&type=style&index=0&id=50f91a61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f91a61",
  null
  
)

export default component.exports